import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IChecklistV2 } from '@fi-shared/checklist/checklist-v2';

@Component({
    selector: 'fi-checklist-edit-container',
    template: ` <fi-checklist2-edit [auditMode]="auditMode" /> `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-edit-container' },
    standalone: false,
})
export class FiChecklistEditContainerComponent {
    @Input() checklist: IChecklistV2;
    @Input({ required: true }) auditMode: boolean;
    constructor() {}
}
